/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { IInternalTelemetry, ITelemetry } from '@msdyn365-commerce/telemetry-internal';
import * as React from 'react';
import { IActionContext, ICoreContext, ICultureInfoFormatter, IRequestContext } from '../interfaces';

export const CoreContext = React.createContext<ICoreContext>({
    actionContext: <IActionContext>{},
    request: <IRequestContext>{},
    telemetry: <ITelemetry>{},
    // @ts-ignore - internalTelemetry is not exposed on the definitions, expected
    internalTelemetry: <IInternalTelemetry>{},
    cultureFormatter: <ICultureInfoFormatter>{},
    app: {}
});
